import { useState, useEffect } from "react";
import LogoOrg from "../img/full_white.png";
import LogoColored from "../img/full_logoC.png";
import { Link, useLocation } from "react-router-dom";
import { FaSearch, FaChevronRight, FaUserAlt } from "react-icons/fa";
import { AiOutlineMenu } from "react-icons/ai";
import axios from "axios";
import SearchModal from "./index/SearchModal";
// import UnifiedSearchModal from "./index/UnifiedSearchModal/UnifiedSearchModal";
// import UnifiedSearchModalMobile from "./index/OtherStyleforSearchModal/SearchModal";
import UnifiedSearchModalDesk from "./index/SearchModalV3/UnifiedSearchModalDesk";

import $ from "jquery";
import Modal from "react-modal";
import "./VCIS/vcis.css";

const Navbar = ({ Ip }) => {
  const location = useLocation();
  const shouldRenderCarouselMenu = location.pathname;
  const SESSION_EXPIRATION_TIME = 5 * 60 * 1000; // 5 minutes of inactivity

  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const [isMobileSubMenu, setIsMobileSubMenu] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVcisModalOpen, setIsVcisModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [password, setPassword] = useState("");
  const [isElligible, setIsElligible] = useState(false);
  const [isMindMap, setIsMindMap] = useState(false);
  let isLoggedIn;

  const handleLogin = () => {
    if (
      (username === "ValAdmin" && password === "ValAdmin") ||
      isLoggedIn === true
    ) {
      setIsElligible(true);
      setIsModalOpen(false);
      localStorage.setItem("isLoggedIn", true);
      isLoggedIn = localStorage.getItem("isLoggedIn");
    } else {
      localStorage.setItem("isLoggedIn", false);
      setIsElligible(false);
      isLoggedIn = localStorage.getItem("isLoggedIn");
    }
  };

  const handleModalOpen = (clicked) => {
    if (!isElligible) {
      setIsModalOpen(true);
      setIsMindMap(false);
    } else {
      setIsMindMap(true);
      setIsModalOpen(false);

      if (clicked === "logout") {
        setIsMindMap(false);
        setIsElligible(false);
        localStorage.setItem("isLoggedIn", false);
        window.location.reload();
      }
    }

    if (clicked === "") {
      setIsMindMap(false);
    }
  };

  const handleLogout = () => {
    localStorage.setItem("isEligible", false);
    localStorage.setItem("access", "0");
    localStorage.removeItem("userData");
    localStorage.setItem("hasAccesDoc", "false");
    window.location.href = "/V-CIS";
  };

  const goToAdmin = () => {
    window.location.href = "/admin";
  };

  const logout = () => {
    localStorage.setItem("isEligible", "false");
    localStorage.setItem("access", "0");
    window.location.href = "/v-cis";
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleVcisModalClose = () => {
    setIsVcisModalOpen(false);
  };

  const handleRegisterModalClose = () => {
    setIsRegisterModalOpen(false);
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };
  const handleFullNameChange = (event) => {
    setFullName(event.target.value);
  };

  const handleMobileChange = (event) => {
    setMobile(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleCompanyChange = (event) => {
    setCompany(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleVcisLogin = async () => {
    setLoading(true);
    setErrorMsg("");

    try {
      const formdata = new FormData();
      formdata.append("userValue", username);
      formdata.append("passValue", password);
      const response = await axios.post(`${Ip}controllers/login.php`, formdata);

      const data = await response.data;

      if (data.status === true) {
        const dateObj = new Date();

        // Extract parts
        const day = dateObj.getDate();
        const dayStr = day < 10 ? `0${day}` : day; // add leading zero if needed
        const month = dateObj.getMonth() + 1; // JS months are 0-indexed
        const monthStr = month < 10 ? `0${month}` : month; // add leading zero if needed
        const year = dateObj.getFullYear().toString().slice(-2); // get last 2 digits

        // Format as "D-M-YY"
        const formatted = `${year}-${monthStr}-${dayStr}`;
        if (data.data.subDate < formatted) {
          setErrorMsg(
            "Your subscription has expired. Please contact us for renewal."
          );
          setLoading(false);
        } else {
          setErrorMsg("");
          localStorage.setItem("isEligible", "true");
          localStorage.setItem("access", data.data.accessLvl);
          localStorage.setItem(
            "expiration",
            `${new Date().getTime() + SESSION_EXPIRATION_TIME}`
          );
          localStorage.setItem("userData", JSON.stringify(data.data));
          handleVcisModalClose();
          window.location.reload();
        }
      } else {
        setErrorMsg(data.message || "Invalid credentials");
      }
    } catch (err) {
      setErrorMsg("Server error. Please try again later.");
    }

    setLoading(false);
  };

  const handleRegister = async () => {
    // Handle registration logic here
    if (!fullName || !email || !company || !mobile || !password) {
      setErrorMsg("Please fill in all fields");
    } else {
      if (
        !/(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=<>?{}[\]~`|\\:;."',./]).{1,}/.test(
          password
        )
      ) {
        setErrorMsg(
          "Password must contain at least one uppercase letter, one number, and one special character (! # $ % & ' ( ) * + , - . / : ; < = > ? @ [  ] ^ _ ` { | } ~ )"
        );
      } else {
        setErrorMsg("");
        setLoading(true);
        console.log(fullName, email, company, mobile, password);
        console.log("Registering...");
        const formdata = new FormData();
        formdata.append("Action", "register");
        formdata.append("fullName", fullName);
        formdata.append("email", email);
        formdata.append("company", company);
        formdata.append("mobile", mobile);
        formdata.append("password", password);
        try {
          const response = await axios.post(
            `${Ip}controllers/register.php`,
            formdata
          );
          const data = await response.data;
          console.log("Response:", data);
          if (data.status === true) {
            setIsRegisterModalOpen(false);
            setIsVcisModalOpen(true);
            setErrorMsg(data.message || "Registration successful");
          } else {
            setErrorMsg(data.message || "Registration failed");
            setLoading(false);
          }
        } catch (err) {
          setErrorMsg("Server error. Please try again later.");
        }
      }
    }
  };

  const handleLinkClick = () => {
    const isEligible = localStorage.getItem("isEligible");
    if (isEligible == "true") {
      $("#subMenuId").toggle();
    } else {
      setIsVcisModalOpen(true);
    }
  };

  const register = () => {
    setIsVcisModalOpen(false);
    setIsRegisterModalOpen(true);
  };

  const login = () => {
    setIsRegisterModalOpen(false);
    setIsVcisModalOpen(true);
  };

  useEffect(() => {
    const expirationTime = localStorage.getItem("expiration");
    const expTimeParsed = parseInt(expirationTime, 10);
    console.log("Expiration Time:", expTimeParsed);
    const isLoggedIn = localStorage.getItem("isEligible");

    const cisMatched = shouldRenderCarouselMenu.toLowerCase().includes("v-cis");
    localStorage.setItem("FirstRender", "no");

    if (isLoggedIn == "true" && cisMatched) {
      const resetExpiration = () => {
        const newExpiration = new Date().getTime() + SESSION_EXPIRATION_TIME;
        localStorage.setItem("expiration", `${newExpiration}`);
      };

      const checkExpiration = () => {
        const expirationTime = parseInt(localStorage.getItem("expiration"), 10);
        const currentTime = new Date().getTime();

        if (currentTime >= expirationTime) {
          logout();
        }
      };

      // Reset expiration on user activity
      const activityEvents = ["mousemove", "keydown", "scroll", "click"];
      activityEvents.forEach((event) =>
        window.addEventListener(event, resetExpiration)
      );

      // Set an interval to check expiration every 10 seconds
      const interval = setInterval(checkExpiration, 10000);

      return () => {
        clearInterval(interval);
        activityEvents.forEach((event) =>
          window.removeEventListener(event, resetExpiration)
        );
      };
    }

    const handleScroll = () => {
      const navbar = document.getElementById("navbar");
      if (navbar) {
        if (window.scrollY > 150) {
          navbar.classList.add("scrolled");
        } else {
          navbar.classList.remove("scrolled");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [shouldRenderCarouselMenu, SESSION_EXPIRATION_TIME]);

  const scrollToSection = (id) => {
    const isHomePage = window.location.pathname === "/";

    if (!isHomePage) {
      localStorage.setItem("targetSection", id);
      window.location.href = "/";
      return;
    }
    const targetId = localStorage.getItem("targetSection") || id;
    setTimeout(() => {
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        console.log("Scrolling to:", targetId);

        if (localStorage.getItem("FirstRender") === "no") {
          localStorage.setItem("FirstRender", "yes");
          setTimeout(() => {
            console.log("Scrolling again to:", targetId);
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 1000);
          setTimeout(() => {
            console.log("Scrolling the third time to:", targetId);
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 2000);
        }
      }

      localStorage.removeItem("targetSection");
    }, 100);
  };

  useEffect(() => {
    const targetSection = localStorage.getItem("targetSection");
    if (targetSection && window.location.pathname === "/") {
      setTimeout(() => {
        const el = document.getElementById(targetSection);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          console.log("Scrolling to stored target:", targetSection);
          localStorage.removeItem("targetSection");
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <div className="navbar" id="navbar">
        <div className="container_content">
          <div className="left_links">
            <div id="mobile_view" className="mobile_menu">
              <AiOutlineMenu
                onClick={() => setIsNavExpanded(!isNavExpanded)}
                style={{ position: "absolute", zIndex: "1" }}
              />
              <div
                className={
                  isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
                }
              >
                <ul>
                  <li>
                    <span onClick={() => scrollToSection("business_scroll")}>
                      Solutions
                    </span>
                  </li>
                  <li>
                    <span onClick={() => scrollToSection("services_scroll")}>
                      Services
                    </span>
                  </li>
                  <li>
                    <span onClick={() => scrollToSection("partners_scroll")}>
                      References
                    </span>
                  </li>
                  <li>
                    <Link target="_blank" to="/V-CIS/documents">
                      Grouping By
                    </Link>
                  </li>
                  <li>
                    <span onClick={() => scrollToSection("media")}>Media</span>
                  </li>
                  <li onClick={() => setIsMobileSubMenu(!isMobileSubMenu)}>
                    <span>About Us</span>
                    {isMobileSubMenu && (
                      <ul className="submenu">
                        <Link target="_blank" to="/News&Events">
                          <li>Events</li>
                        </Link>
                        <Link target="_blank" to="/LetterOfCeo">
                          <li>CEO'S Letter</li>
                        </Link>
                        <Link target="_blank" to={`/aboutUs?variable=Contact`}>
                          <li>Contact Us</li>
                        </Link>
                        <Link target="_blank" to="/hr/career">
                          <li>Recruitment</li>
                        </Link>
                        <Link target="_blank" to="/hr/academy">
                          <li>Academy</li>
                        </Link>
                        <Link target="_blank" to="/aboutUs/logo">
                          <li>The Logo</li>
                        </Link>
                      </ul>
                    )}
                  </li>
                </ul>
              </div>
            </div>
            <div className="logo">
              <Link target="_blank" to="/">
                <img id="logo_img" src={LogoOrg} alt="" />
              </Link>
            </div>
            <div className="links" id="pc_view">
              <span
                className="link"
                onClick={() => scrollToSection("business_scroll")}
              >
                Solutions
              </span>
              <span
                className="link"
                onClick={() => scrollToSection("services_scroll")}
              >
                Services
              </span>
              <span
                className="link"
                onClick={() => scrollToSection("partners_scroll")}
              >
                References
              </span>
              <span className="link" onClick={() => scrollToSection("media")}>
                Media
              </span>
              <Link target="_blank" to="/V-CIS/documents" className="link">
                Grouping By
              </Link>
              <div className="link" id="open_menu">
                <h6 style={{ fontSize: "1.15rem", fontWeight: "normal" }}>
                  About Us
                </h6>
                <ul className="submenu">
                  <Link target="_blank" to="/News&Events">
                    <li>Events</li>
                  </Link>
                  <Link target="_blank" to="/LetterOfCeo">
                    <li>CEO'S Letter</li>
                  </Link>
                  <Link target="_blank" to={`/aboutUs?variable=Contact`}>
                    <li>Contact Us</li>
                  </Link>

                  {/* <Link target="_blank" to='https://hr.valoores.com/'> */}
                  <li
                    className="d-flex flex-row align-items-center justify-content-between"
                    id="open_hrMenu"
                  >
                    HR
                    <FaChevronRight />
                    <ul className="subHrMenu" id="subHrMenu">
                      <Link target="_blank" to="/hr/career">
                        <li>Recruitment</li>
                      </Link>
                      <Link target="_blank" to="/hr/academy">
                        <li>Academy</li>
                      </Link>
                    </ul>
                  </li>
                  {/* </Link> */}

                  {/* <Link target="_blank" to='https://valoores.com/thelogo.php'> */}
                  <Link target="_blank" to="/aboutUs/logo">
                    <li>The Logo</li>
                  </Link>

                  {/* <Link target="_blank" to={`/aboutUs?variable=Ceo`}>
                    <li>Word Of The CEO</li>
                  </Link> */}

                  {/* <Link target="_blank" to={`/aboutUs?variable=Mission`}>
                    <li>Mission and Vision</li>
                  </Link> */}

                  {/* <Link target="_blank" to={`/aboutUs?variable=Leaders`}>
                    <li>Executive Leadership</li>
                  </Link> */}
                </ul>
              </div>
            </div>
          </div>

          <div className="side_links">
            {/* <span>
              <FaSearch />
            </span> */}
            <div>
              {/* <SearchModal Ip={Ip} /> */}
              <UnifiedSearchModalDesk Ip={Ip} />
              {shouldRenderCarouselMenu.toLowerCase().includes("v-cis") && (
                <span
                  onClick={handleLinkClick}
                  style={{ position: "fixed", right: "15px", top: "28px" }}
                >
                  <FaUserAlt style={{ width: "22px", height: "22px" }} />
                </span>
              )}
              {shouldRenderCarouselMenu.toLowerCase().includes("v-cis") &&
              localStorage.getItem("isEligible") == "true"
                ? document.referrer != ""
                  ? (() => {
                      return localStorage.getItem("access") == "1" ? (
                        <ul className="subMenuMind" id="subMenuId">
                          <li onClick={goToAdmin}>Dashboard</li>
                          <li onClick={handleLogout}>Logout</li>
                        </ul>
                      ) : (
                        <ul className="subMenuMind" id="subMenuId">
                          <li onClick={handleLogout}>Logout</li>
                        </ul>
                      );
                    })()
                  : (document.location.href = "./")
                : isMindMap &&
                  isElligible && (
                    <ul className="subMenuMind">
                      <Link
                        to="./MindMap"
                        onClick={() => handleModalOpen("closeSubMenu")}
                        target="_blank"
                        style={{ textDecoration: "none", color: "#777" }}
                      >
                        <li>Mind Map</li>
                      </Link>
                      <li onClick={() => handleModalOpen("logout")}>Logout</li>
                    </ul>
                  )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleModalOpen}
        contentLabel="Add Modal"
        className="ReactModal__Content_navbar"
        style={{ top: "30%!important" }}
      >
        <div className="">
          <div className="">
            <div className="">
              <div className="row px-4 d-flex flex-column align-items-center justify-content-center">
                <span
                  onClick={handleModalClose}
                  className="text-end clodeModal"
                  style={{ cursor: "pointer" }}
                >
                  X
                </span>
                <img src={LogoColored} className="w-75 mb-5" alt="" />
                <div className="col-md-12">
                  <input
                    type="text"
                    placeholder="Username Or Email"
                    value={username}
                    onChange={handleUsernameChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mt-4">
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={handlePasswordChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="px-4 d-flex justify-content-center gap-3 mt-5">
                <button className="btn btn-danger w-75" onClick={handleLogin}>
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isVcisModalOpen}
        onRequestClose={handleVcisModalClose}
        contentLabel="Add Modal"
        className="ReactModal__Content_navbar"
        style={{ top: "30%!important" }}
      >
        <div className="">
          <div className="">
            <div className="">
              <div className="row px-4 pt-0 d-flex flex-column align-items-center justify-content-center">
                <span
                  onClick={handleVcisModalClose}
                  className="text-end clodeModal"
                  style={{ cursor: "pointer" }}
                >
                  X
                </span>
                <img src={LogoColored} className="w-75 mb-2" alt="" />
                <h4 className="mb-4">Login</h4>
                <div className="col-md-12">
                  <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={handleUsernameChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mt-4">
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={handlePasswordChange}
                    className="form-control"
                  />
                </div>
                <p
                  style={{
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={register}
                >
                  Request Access
                </p>
                {errorMsg && <p className="text-danger">{errorMsg}</p>}
              </div>
              <div className="d-flex justify-content-end pe-4">
                <button
                  className="btn btn-secondary me-2"
                  onClick={handleVcisModalClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleVcisLogin}
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isRegisterModalOpen}
        onRequestClose={handleRegisterModalClose}
        contentLabel="Add Modal"
        className="ReactModal__Content_navbar"
        style={{ top: "30%!important" }}
      >
        <div className="">
          <div className="">
            <div className="">
              <div className="row px-4 pt-0 d-flex flex-column align-items-center justify-content-center">
                <span
                  onClick={handleRegisterModalClose}
                  className="text-end clodeModal"
                  style={{ cursor: "pointer" }}
                >
                  X
                </span>
                <img src={LogoColored} className="w-75 mb-2" alt="" />
                <h4 className="mb-4">Request Access</h4>
                <div className="col-md-12">
                  <input
                    type="text"
                    placeholder="Full Name"
                    value={fullName}
                    onChange={handleFullNameChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mt-4">
                  <input
                    type="text"
                    placeholder="Email"
                    value={email}
                    onChange={handleEmailChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mt-4">
                  <input
                    type="text"
                    placeholder="Company Name"
                    value={company}
                    onChange={handleCompanyChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mt-4">
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    value={mobile}
                    onChange={handleMobileChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mt-4">
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={handlePasswordChange}
                    className="form-control"
                  />
                </div>
                {errorMsg && (
                  <p style={{ fontSize: "14px" }} className="text-danger">
                    {errorMsg}
                  </p>
                )}
                <span style={{ fontSize: "14px" }}>
                  already have an account?
                </span>
                <span
                  style={{
                    color: "blue",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={login}
                >
                  Log In
                </span>
              </div>
              <div className="d-flex justify-content-end pe-4">
                <button
                  className="btn btn-secondary me-2"
                  onClick={handleRegisterModalClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleRegister}
                  disabled={loading}
                >
                  {loading ? "Sending Request..." : "Request Access"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Navbar;
